//import { mergeDeep } from './../utils/js/shared_helpers.js';
import { getParameterByName } from '../utils/js/browser_helpers'

/**********
SHARED REDUCERS
**********/

export const data = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return {}
        case 'WS_GAME_DATA_RECEIVED':
        case 'AJAX_GAME_DATA_RECEIVED':
            return action.window_location === action.gamecode
                ? Object.assign({}, state, action.gamedata)
                : state
        default:
            return state
    }
}
//return action.window_location === action.gamecode ? mergeDeep(state, action.gamedata) : state; <--- IF WE EVER DECIDE TO USE MERGEDEEP, USE THIS WHEN RETURNING FROM AJAX_GAME_DATA_RECEIVED ACTION

export const status = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return {}
        case 'AJAX_GAME_DATA_RECEIVED':
            return action.status
        default:
            return state
    }
}

export const secondaryStatus = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return {}
        case 'AJAX_GAME_DATA_RECEIVED':
            return action.secondaryStatus
        default:
            return state
    }
}

export const routeId = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return action.id
        default:
            return state
    }
}

export const teamId = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE_TEAM':
            return action.id
        default:
            return state
    }
}

export const location = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return action.location
        default:
            return state
    }
}

export const isFetching = (state = {}, action) => {
    switch (action.type) {
        case 'AJAX_GAME_DATA_REQUEST':
        case 'ROUTE_CHANGE':
        case 'WS_DISCONNECTED':
            return true
        case 'WS_GAME_DATA_RECEIVED':
        case 'AJAX_GAME_DATA_RECEIVED':
        case 'AJAX_ERROR':
            return false
        default:
            return state
    }
}

export const fourohfour = (state = false, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return false
        case 'NOT_AVAILABLE':
            return true
        default:
            return false
    }
}

export const trackerUnavailable = (state = {}, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return {}
        case 'AJAX_ERROR':
            return true
        case 'WS_GAME_DATA_RECEIVED':
        case 'AJAX_GAME_DATA_RECEIVED':
            return false
        default:
            return state
    }
}

export const ads = (state = 0, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return 0
        case 'AD_ITERATOR':
            return state + 1
        default:
            return state
    }
}

export const sectionTitle = (state = '', action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return ''
        case 'SECTION_TITLE':
            return action.section_title
        default:
            return state
    }
}

export const isMobileApp = (state = false, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return getParameterByName('template') === 'basic'
        default:
            return state
    }
}

export const mobileDevice = (state = false, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            let userAgent = navigator.userAgent || navigator.vendor || window.opera
            if (/android/i.test(userAgent)) {
                return 'android'
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return 'ios'
            } else {
                return false
            }
        default:
            return state
    }
}

export const summaryVideo = (state = {}, action) => {
    switch (action.type) {
        case 'GET_SUMMARY_VIDEO':
            return action.data
        default:
            return state
    }
}

export const navMenuCollapsed = (state = true, action) => {
    switch (action.type) {
        case 'NAV_MENU_COLLAPSED':
            return action.collapsed
        default:
            return state
    }
}

export const soccerLeagueOrder = (state = [], action) => {
    switch (action.type) {
        case 'SOCCER_LEAGUE_ORDER':
            return action.ordered_leagues
        default:
            return state
    }
}

export const juniorsLeagueOrder = (state = [], action) => {
    switch (action.type) {
        case 'JUNIORS_LEAGUE_ORDER':
            return action.ordered_leagues
        default:
            return state
    }
}

export const ticker = (
    state = {
        open: false,
        loading: false,
        games: [],
        error: false,
        service: false,
        service_message: '',
    },
    action
) => {
    switch (action.type) {
        case 'TICKER_INIT_FEED_REQUEST':
            return {
                ...state,
                open: false,
                loading: true,
            }
        case 'TICKER_DATA_RECEIVED':
            return {
                ...state,
                ...action.data,
                loading: false,
            }
        case 'TICKER_FEED_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
            }
        case 'TICKER_TOGGLE':
            return {
                ...state,
                open: action.tickerOpen,
            }
        default:
            return state
    }
}
